import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export * from "./utils/tone"
export * from "./utils/validation"
export * from "./utils/chartColors"
